import get from "lodash/get.js";

function filterItem(item, itemFilter) {
  if (!itemFilter?.field || !itemFilter?.operator || !itemFilter?.value)
    return true;
  if (!item) return false;

  const prop = get(item, itemFilter.field);
  if (itemFilter.operator === "is_equal_to") return prop === itemFilter.value;
  if (itemFilter.operator === "is_not_equal_to")
    return prop !== itemFilter.value;
  if (itemFilter.operator === "contains") {
    return (
      prop &&
      prop.toString().toLowerCase().includes(itemFilter.value.toLowerCase())
    );
  }
  if (itemFilter.operator === "is_one_of") {
    return itemFilter.value?.includes(prop);
  }
  if (itemFilter.operator === "is_not_one_of") {
    return !itemFilter.value?.includes(prop);
  }
}

function filterItems(items, itemFilter) {
  if (!itemFilter?.field || !itemFilter?.operator || !itemFilter?.value)
    return items;

  return items.filter((item) => {
    const prop = get(item, itemFilter.field);
    if (itemFilter.operator === "is_equal_to") return prop === itemFilter.value;
    if (itemFilter.operator === "is_not_equal_to")
      return prop !== itemFilter.value;
    if (itemFilter.operator === "contains") {
      return (
        prop &&
        prop.toString().toLowerCase().includes(itemFilter.value.toLowerCase())
      );
    }
    if (itemFilter.operator === "is_one_of") {
      return itemFilter.value?.includes(prop);
    }
    if (itemFilter.operator === "is_not_one_of") {
      return !itemFilter.value?.includes(prop);
    }
  });
}

function filterTypes(types, items, settings) {
  if (settings?.show_categories_with_no_items) return types;

  const presentTypes = items.reduce((acc, item) => {
    if (item.type_id != undefined) {
      acc[item.type_id] = true;
    }
    return acc;
  }, {});

  return types.filter((t) => presentTypes[t.id]);
}

function itemsInCategories(items, collections, types, settings) {
  if (settings?.group_by === "opening") {
    const presentCollections = collections.reduce((acc, c) => {
      acc[c.id] = true;
      return acc;
    }, {});

    return items.filter((item) => {
      if (item.collection_id) {
        return presentCollections[item.collection_id];
      }

      return settings.show_untyped_items;
    });
  } else {
    const presentTypes = types.reduce((acc, t) => {
      acc[t.id] = true;
      return acc;
    }, {});

    return items.filter((item) => {
      if (item.type_id) {
        return presentTypes[item.type_id];
      }

      return settings?.show_untyped_items;
    });
  }
}

function locRecord(location, grp) {
  if (!location) return null;

  if (location.record_type === "type") {
    return grp.types[location.record_id];
  } else if (location.record_type === "document_note") {
    return grp.document_notes[location.record_id];
  } else {
    return grp.items[location.record_id];
  }
}

function isLocationVisible(location, grp, filters) {
  if (!location) return false;
  const record = locRecord(location, grp);
  if (!record) return false;

  if (!filters) return true;

  if (filters?.hidden_locations?.[location.id]) return false;

  if (
    filters?.location_filter &&
    !filterItem(location, filters?.location_filter)
  ) {
    return false;
  }

  if (location.record_type === "type" && record && filters?.show_types) {
    return filterItem(record, filters?.type_filter);
  } else if (location.record_type === "item" && record && filters?.show_items) {
    return filterItem(record, filters?.item_filter);
  } else if (
    location.record_type === "collection" &&
    record &&
    filters?.show_collections
  ) {
    return filterItem(record, filters?.collection_filter);
  } else if (
    location.record_type === "document_note" &&
    record &&
    filters?.show_notes
  ) {
    return filterItem(record, filters?.note_filter);
  }

  return false;
}

export {
  locRecord,
  filterItems,
  filterTypes,
  filterItem,
  itemsInCategories,
  isLocationVisible,
};
